/**
 * Chart of Accounts contracts — espelho 1:1 do `ChartOfAccountsController`
 * (treasury_service). Convenção PascalCase em todos os campos; o backend
 * serializa em PascalCase e o front consome sem mapeamento de casing.
 *
 * Source of truth: `libs/domains/treasury/CHART_OF_ACCOUNTS_API.md`
 */

/** Classificação contábil. Determina compatibilidade com direção do lançamento. */
export enum ChartOfAccountsNodeNature {
  Revenue = 0,
  Deduction = 1,
  Cost = 2,
  OperationalExpense = 3,
  FinancialIncome = 4,
  FinancialExpense = 5,
}

/** Seção do DRE em que a conta aparece (herdada do nó pai ao criar leaf). */
export enum DreSection {
  GrossRevenue = 0,
  RevenueDeduction = 1,
  CostOfServices = 2,
  OperatingExpenses = 3,
  FinancialItems = 4,
}

/** Naturezas compatíveis com lançamentos de **entrada** (`FlowDirection.In`). */
export const IN_NATURES: readonly ChartOfAccountsNodeNature[] = [
  ChartOfAccountsNodeNature.Revenue,
  ChartOfAccountsNodeNature.FinancialIncome,
] as const;

/** Naturezas compatíveis com lançamentos de **saída** (`FlowDirection.Out`). */
export const OUT_NATURES: readonly ChartOfAccountsNodeNature[] = [
  ChartOfAccountsNodeNature.Deduction,
  ChartOfAccountsNodeNature.Cost,
  ChartOfAccountsNodeNature.OperationalExpense,
  ChartOfAccountsNodeNature.FinancialExpense,
] as const;

/** Direção de lançamento aceita pelo backend ao validar `ChartOfAccountsNodeId`. */
export type ChartOfAccountsDirection = 'In' | 'Out';

/**
 * Nó da árvore. Recursivo via `Children`. Apenas folhas (`IsLeaf=true`)
 * podem ser vinculadas a um `CashFlowEntry`.
 */
export interface ChartOfAccountsNodeViewModel {
  NodeId: string;
  Code: string;
  Name: string;
  Level: number;
  Nature: ChartOfAccountsNodeNature;
  DreSection: DreSection;
  IsLeaf: boolean;
  IsActive: boolean;
  IsSystemDefined: boolean;
  Children: ChartOfAccountsNodeViewModel[];
}

/** Wrapper retornado por `GET /ChartOfAccounts/GetTree`. */
export interface ChartOfAccountsTreeViewModel {
  Roots: ChartOfAccountsNodeViewModel[];
}

/** Payload de `POST /ChartOfAccounts/AddLeafNode`. */
export interface AddLeafNodeRequest {
  ParentNodeId: string;
  Name: string;
  SortOrder?: number;
}
